export default function getCountryByCurrency (currency?: string) {
  switch (currency) {
    case 'eur':
      return 'DE';
    case 'gbp':
      return 'GB';
    case 'usd':
    default:
      return 'US';
  }
};
